import {
  withSanitize_default
} from "./chunk-PZEXS2W7.mjs";
import {
  custom_select_default
} from "./chunk-G2GT5CLT.mjs";
import {
  help_center_error_boundary_default
} from "./chunk-MT5EODQB.mjs";
import {
  SearchInput
} from "./chunk-QFJV6DV6.mjs";
import {
  createResource
} from "./chunk-3HLJJFGT.mjs";
import {
  getMimeType
} from "./chunk-2XGW26V2.mjs";
import {
  sanitization
} from "./chunk-4ZAFAYNX.mjs";
import {
  StyledContentWrapper
} from "./chunk-EHT33PON.mjs";
import {
  HelpCenterFooter
} from "./chunk-FRDH7SNC.mjs";
import {
  HelpCenterHandlerCloseEvent
} from "./chunk-VXLRIQ7S.mjs";
import {
  HelpCenterTicketCreatedFooter
} from "./chunk-WULIC3LN.mjs";
import {
  useEvents
} from "./chunk-TFRVQL75.mjs";
import {
  HelpCenterEvents
} from "./chunk-AOTFDLGI.mjs";
import {
  SidePanelHeader
} from "./chunk-A2UNT4DX.mjs";
import {
  useLayoutContext
} from "./chunk-HFINPXUM.mjs";

// src/internal/components/help-center-panel/hooks/useArticleRequest.tsx
import { useAuthContext as useAuthContext2, useAuthFetch as useAuthFetch2 } from "@clara/auth";
import { useAsyncFn as useAsyncFn2 } from "@clara/hooks";
import { useLocaleContext as useLocaleContext3 } from "@clara/locale";

// src/internal/components/help-center-panel/help-center-panel.tsx
import { useMemo as useMemo4 } from "react";
import { Translation } from "@clara/locale";
import { createContext } from "@clara/react-utils";
import { runIfFn } from "@clara/utils";

// src/internal/components/help-center-panel/help-center-article/help-center-article-title.tsx
import { useT } from "@clara/locale";
import { jsx } from "react/jsx-runtime";
var HelpCenterArticleTitle = ({ id }) => {
  const { t } = useT("common");
  const { getArticle } = useHelpCenterContext();
  const article = getArticle(id);
  const isUseCase = (article == null ? void 0 : article.type) === "use_case" /* USE_CASE */;
  return /* @__PURE__ */ jsx(
    SidePanelHeader,
    {
      variant: "alternate",
      headline: isUseCase ? article.title : t("helpCenter.panel.article.title"),
      tagline: isUseCase ? null : article == null ? void 0 : article.title
    }
  );
};

// src/internal/components/help-center-panel/help-center-article/help-center-ticket-created.tsx
import { format } from "date-fns";
import { enUS, es, ptBR } from "date-fns/locale";
import { Box, Divider, List, Stack, Typography } from "@mui/material";
import { useLocaleContext, useT as useT2 } from "@clara/locale";
import { Flex, Image, theme } from "@clara/ui";
import { Fragment, jsx as jsx2, jsxs } from "react/jsx-runtime";
var HelpCenterTicketCreated = () => {
  const { t } = useT2("common");
  const { ticket } = useHelpCenterContext();
  const { locale } = useLocaleContext();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx2(
      Image,
      {
        src: "https://clara-all-assets-prod.s3.amazonaws.com/help-center/bulk-creation.svg",
        width: "160px",
        marginX: "auto",
        mb: 2
      }
    ),
    /* @__PURE__ */ jsxs(Stack, { spacing: 1, mb: 2, children: [
      /* @__PURE__ */ jsx2(Typography, { variant: "h2", align: "center", children: t("helpCenter.panel.ticketCreated.title") }),
      /* @__PURE__ */ jsx2(Typography, { variant: "body1", align: "center", children: t("helpCenter.panel.ticketCreated.description") })
    ] }),
    /* @__PURE__ */ jsx2(Stack, { spacing: 1, children: /* @__PURE__ */ jsxs(List, { children: [
      /* @__PURE__ */ jsxs(Flex, { justifyContent: "space-between", my: 1.5, children: [
        /* @__PURE__ */ jsx2(
          Typography,
          {
            variant: "body1",
            color: theme.palette.v3.content.low_emphasis,
            children: t("helpCenter.panel.ticketCreated.ticketNumber")
          }
        ),
        /* @__PURE__ */ jsxs(Typography, { variant: "body1", children: [
          "#",
          ticket == null ? void 0 : ticket.id
        ] })
      ] }),
      /* @__PURE__ */ jsx2(Divider, {}),
      /* @__PURE__ */ jsxs(Flex, { justifyContent: "space-between", my: 1.5, children: [
        /* @__PURE__ */ jsx2(
          Typography,
          {
            variant: "body1",
            color: theme.palette.v3.content.low_emphasis,
            children: t("helpCenter.panel.ticketCreated.reportedDate")
          }
        ),
        /* @__PURE__ */ jsx2(Typography, { variant: "body1", children: /* @__PURE__ */ jsx2(Box, { sx: { textTransform: "capitalize" }, children: format(/* @__PURE__ */ new Date(), "dd MMMM yyyy", {
          locale: locale.i18n.language.includes("es") ? es : locale.i18n.language.includes("pt") ? ptBR : enUS
        }) }) })
      ] }),
      /* @__PURE__ */ jsx2(Divider, {}),
      /* @__PURE__ */ jsxs(Flex, { justifyContent: "space-between", my: 1.5, children: [
        /* @__PURE__ */ jsx2(
          Typography,
          {
            variant: "body1",
            color: theme.palette.v3.content.low_emphasis,
            children: t("helpCenter.panel.ticketCreated.issue")
          }
        ),
        /* @__PURE__ */ jsx2(Typography, { variant: "body1", children: ticket == null ? void 0 : ticket.subject })
      ] }),
      /* @__PURE__ */ jsx2(Divider, {})
    ] }) })
  ] });
};

// src/internal/components/help-center-panel/help-center-article/use-case-components/render-html.tsx
import { useEffect, useRef } from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var RenderHTML = ({ innerHTML }) => {
  const containerRef = useRef(null);
  const { sidePanel } = useLayoutContext();
  useEffect(() => {
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = sanitization(innerHTML);
    const anchors = tempContainer.querySelectorAll("a");
    const handleClick = (event) => {
      const articleId = event.currentTarget.dataset.articleId;
      if (articleId) {
        event.preventDefault();
        sidePanel.onOpen(
          createArticlePanels(sidePanel.panels, articleId),
          sidePanel.panels.length
        );
      }
    };
    anchors.forEach((anchor) => {
      anchor.addEventListener("click", handleClick);
    });
    if (containerRef.current) {
      const curr = containerRef.current;
      curr.innerHTML = "";
      curr.appendChild(tempContainer);
    }
    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener("click", handleClick);
      });
    };
  }, [innerHTML, sidePanel]);
  return /* @__PURE__ */ jsx3(StyledContentWrapper, { children: /* @__PURE__ */ jsx3("div", { ref: containerRef }) });
};
var render_html_default = RenderHTML;

// src/internal/components/help-center-panel/help-center-content/help-center-assistant.tsx
import { Fragment as Fragment2, Suspense, useEffect as useEffect2, useState } from "react";
import {
  Divider as Divider2,
  List as List2,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Stack as Stack2,
  Typography as Typography2
} from "@mui/material";
import { useAnalytics } from "@clara/events";
import { ChevronRightIcon } from "@clara/icons";
import { useT as useT3 } from "@clara/locale";
import { EmptyState, Flex as Flex2, Image as Image2 } from "@clara/ui";
import { Fragment as Fragment3, jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
function removeSingleHtmlTags(text) {
  const regex = /<[^>]+>/g;
  return text.replace(regex, "");
}
var HelpCenterAssistant = () => {
  const { articleList } = useArticleRequest();
  const [, onSubmit] = articleList;
  const [resource, setResource] = useState(null);
  const [search, setSearch] = useState("");
  const analytics = useAnalytics();
  const { eventData } = useEvents();
  useEffect2(() => {
    setResource(
      createResource(onSubmit(search))
    );
  }, [onSubmit, search]);
  useEffect2(() => {
    if (search) {
      analytics.track(HelpCenterEvents.EXPERIENCE_HELPERSIDE_SEARCH, {
        ...eventData,
        action: "search",
        intent: search
      });
    }
  }, [search]);
  return /* @__PURE__ */ jsx4(
    help_center_error_boundary_default,
    {
      trackError: analytics.track,
      eventData: { ...eventData, action: "error" },
      children: /* @__PURE__ */ jsxs2(Stack2, { gap: 4, children: [
        /* @__PURE__ */ jsx4(SearchInput, { onChange: setSearch }),
        /* @__PURE__ */ jsx4(Suspense, { fallback: /* @__PURE__ */ jsx4(HelpCenterFallback, {}), children: resource && /* @__PURE__ */ jsx4(ArticleList, { resource }) })
      ] })
    }
  );
};
var ArticleList = ({ resource }) => {
  const { t } = useT3("common");
  const { sidePanel } = useLayoutContext();
  const { update } = useHelpCenterContext();
  const articles = resource.read();
  return /* @__PURE__ */ jsxs2(Stack2, { gap: 2, children: [
    !!articles.length && /* @__PURE__ */ jsx4(Typography2, { variant: "subtitle2", children: t("helpCenter.panel.recommendedArticles") }),
    !articles.length && /* @__PURE__ */ jsx4(
      EmptyState,
      {
        renderImage: () => /* @__PURE__ */ jsx4(Image2, { src: "https://clara-all-assets-prod.s3.amazonaws.com/help-center/no-results.svg" }),
        headline: t("helpCenter.panel.emptySearch.title"),
        tagline: t("helpCenter.panel.emptySearch.tagline")
      }
    ),
    /* @__PURE__ */ jsx4(List2, { children: articles == null ? void 0 : articles.map((article) => {
      var _a;
      return /* @__PURE__ */ jsxs2(Fragment2, { children: [
        /* @__PURE__ */ jsxs2(
          ListItemButton,
          {
            onClick: () => {
              var _a2;
              update({
                id: article.id,
                title: article.title,
                snippet: `${(_a2 = article.snippet) == null ? void 0 : _a2.substring(0, 50)}...`,
                labels: article.labels,
                body: article.body
              });
              sidePanel.onOpen(
                createArticlePanels(sidePanel.panels, `${article.id}`),
                sidePanel.panels.length
              );
            },
            children: [
              /* @__PURE__ */ jsx4(
                ListItemText,
                {
                  primary: article.title,
                  secondary: `${(_a = removeSingleHtmlTags(article.snippet)) == null ? void 0 : _a.substring(
                    0,
                    50
                  )}...`
                }
              ),
              /* @__PURE__ */ jsx4(ListItemIcon, { children: /* @__PURE__ */ jsx4(ChevronRightIcon, { fontSize: "large" }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx4(Divider2, {})
      ] }, article.id);
    }) })
  ] });
};
var HelpCenterFallback = ({ showTitle = true }) => {
  const { t } = useT3("common");
  return /* @__PURE__ */ jsxs2(Fragment3, { children: [
    /* @__PURE__ */ jsx4(Stack2, { mb: 2, children: showTitle && /* @__PURE__ */ jsx4(Typography2, { variant: "subtitle2", children: t("helpCenter.panel.recommendedArticles") }) }),
    /* @__PURE__ */ jsxs2(Stack2, { gap: 1, children: [
      /* @__PURE__ */ jsx4(Flex2, { width: "100%", children: /* @__PURE__ */ jsx4(Skeleton, { variant: "rectangular", height: 82 }) }),
      /* @__PURE__ */ jsx4(Flex2, { width: "100%", children: /* @__PURE__ */ jsx4(Skeleton, { variant: "rectangular", height: 82 }) }),
      /* @__PURE__ */ jsx4(Flex2, { width: "100%", children: /* @__PURE__ */ jsx4(Skeleton, { variant: "rectangular", height: 82 }) }),
      /* @__PURE__ */ jsx4(Flex2, { width: "100%", children: /* @__PURE__ */ jsx4(Skeleton, { variant: "rectangular", height: 82 }) })
    ] })
  ] });
};

// src/internal/components/help-center-panel/help-center-article/help-center-article.tsx
import { Suspense as Suspense2, useEffect as useEffect4, useState as useState3 } from "react";
import { useAnalytics as useAnalytics3 } from "@clara/events";

// src/internal/components/help-center-panel/help-center-article/help-center-common-article.tsx
import { Fragment as Fragment4, jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var CommonArticle = ({ article }) => {
  return /* @__PURE__ */ jsxs3(Fragment4, { children: [
    /* @__PURE__ */ jsx5(render_html_default, { innerHTML: article.body }),
    "ticket" /* TICKET */ === article.type && /* @__PURE__ */ jsx5(HelpCenterFooter, {})
  ] });
};
var help_center_common_article_default = CommonArticle;

// src/internal/components/help-center-panel/help-center-article/help-center-use-case.tsx
import { useMemo as useMemo3 } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { bool, mixed, object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack as Stack5 } from "@mui/material";

// src/internal/components/help-center-panel/help-center-article/help-center-article-footer.tsx
import { useEffect as useEffect3 } from "react";
import { useFormContext } from "react-hook-form";
import { Stack as Stack3, Typography as Typography3 } from "@mui/material";
import { Button } from "@clara/button";
import { useT as useT4 } from "@clara/locale";
import { DrawerFooter, theme as theme2, useSnackbar as useSnackbar2 } from "@clara/ui";

// src/internal/components/help-center-panel/hooks/useTicket.tsx
import { useAnalytics as useAnalytics2 } from "@clara/events";
import { useAuthContext, useAuthFetch } from "@clara/auth";
import { useAsyncFn } from "@clara/hooks";
import { useSnackbar } from "@clara/ui";
import { __DEV__ } from "@clara/utils";
var useTicket = () => {
  const request = useAuthFetch();
  const analytics = useAnalytics2();
  const { eventData } = useEvents();
  const { user, config } = useAuthContext();
  const snackbar = useSnackbar();
  const API_URL = config.url;
  const { zendeskHost } = useHelpCenterContext();
  const readFileAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function(event) {
        var _a;
        resolve((_a = event.target) == null ? void 0 : _a.result);
      };
      reader.onerror = function(error) {
        reject(error);
      };
      reader.readAsArrayBuffer(file);
    });
  };
  const attachFile = useAsyncFn(
    async (file) => {
      if (!zendeskHost) {
        if (__DEV__) {
          console.warn(
            "Warning: Zendesk host is not defined. To attach files on Dynamic forms, ensure the Zendesk host is configured. More Information: https://www.notion.so/clarahub/Help-Center-Side-Panel-integration-fb48e500fa8448d19e964018bfd9aa61?pvs=4#1775c2de70ca46c7a71ba179f45d56ab"
          );
        }
        return null;
      }
      const arrayBuffer = await readFileAsArrayBuffer(file).catch((error) => {
        snackbar({
          message: "Error while attaching file",
          status: "error",
          position: "bottom-left"
        });
        throw new Error(error);
      });
      const response = await fetch(
        `https://${zendeskHost}.zendesk.com/api/v2/uploads?filename=${file.name}`,
        {
          method: "POST",
          body: arrayBuffer,
          headers: {
            "Content-Type": "application/binary"
          }
        }
      );
      return response;
    },
    [request]
  );
  const createTicket = useAsyncFn(
    async (fields, articlePurpose) => {
      const attachments = Object.entries(fields).filter(([name]) => name.includes("attachment" /* ATTACHMENT */)).map(([, value]) => value).flat().filter((file) => !!file);
      const response = await request(
        `${API_URL}/help-center/tickets/create-from-article`,
        {
          method: "POST",
          body: JSON.stringify({
            articlePurpose,
            attachments,
            userEmail: user == null ? void 0 : user.email,
            customFields: Object.entries(fields).map(([name, value]) => ({
              id: name,
              value
            })).filter(
              (field) => {
                var _a;
                return !field.id.includes("attachment" /* ATTACHMENT */) && !!((_a = field.value) == null ? void 0 : _a.toString().trim());
              }
            )
          })
        }
      );
      analytics.track(HelpCenterEvents.EXPERIENCE_HELPERSIDE_CREATE_TICKET, {
        ...eventData,
        action: "create_ticket",
        ticket: response.ticketId
      });
      return response;
    },
    [request]
  );
  return { attachFile, createTicket };
};

// src/internal/components/help-center-panel/help-center-article/help-center-article-footer.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var getButtonLabelFromArticles = (article) => {
  const container = document.createElement("div");
  container.innerHTML = article.body;
  const button = container.querySelector("div[data-type='submit']");
  const label = button == null ? void 0 : button.getAttribute("data-label");
  const description = button == null ? void 0 : button.getAttribute("data-description");
  return { label, description };
};
var UseCaseButton = ({ article }) => {
  var _a;
  const { setTicket } = useHelpCenterContext();
  const { sidePanel } = useLayoutContext();
  const {
    createTicket: [{ loading, error }, onSubmit]
  } = useTicket();
  const snackbar = useSnackbar2();
  const { t } = useT4("common");
  const defaultBtnLabel = t("helpCenter.panel.useCase.button.defaultLabel");
  const buttonInfo = getButtonLabelFromArticles(article);
  useEffect3(() => {
    if (error) {
      snackbar({
        message: t("helpCenter.panel.useCase.errorMessage"),
        status: "error",
        position: "bottom-left",
        isClosable: true
      });
    }
  }, [error, snackbar, t]);
  const {
    handleSubmit,
    formState: { isValid }
  } = useFormContext();
  const submit = async (data) => {
    const articlePurpose = article.labels.find(
      (label) => label.toLowerCase().includes("tickettype")
    );
    const response = await onSubmit(data, articlePurpose == null ? void 0 : articlePurpose.toLowerCase());
    setTicket({
      id: response.ticketId
    });
    sidePanel.onOpen(TicketCreatedPanel, 0);
  };
  return /* @__PURE__ */ jsx6(
    DrawerFooter,
    {
      sx: {
        position: "absolute",
        justifyContent: "center",
        bottom: 0,
        left: 0,
        width: "100%",
        background: "white",
        zIndex: 1,
        "&:after": {
          content: "''",
          display: "block"
        }
      },
      children: /* @__PURE__ */ jsxs4(Stack3, { spacing: 2, children: [
        /* @__PURE__ */ jsx6(
          Button,
          {
            width: "fit-content",
            margin: "auto",
            isLoading: loading,
            isDisabled: !isValid,
            onClick: handleSubmit(submit),
            sx: { minWidth: 208, margin: "auto !important" },
            children: (_a = buttonInfo.label) != null ? _a : defaultBtnLabel
          }
        ),
        !!buttonInfo.description && /* @__PURE__ */ jsx6(
          Typography3,
          {
            sx: { textAlign: "center" },
            variant: "caption",
            color: theme2.palette.v3.content.low_emphasis,
            children: buttonInfo.description
          }
        )
      ] })
    }
  );
};

// src/internal/components/help-center-panel/help-center-article/use-case-components/render-form.tsx
import { useMemo as useMemo2 } from "react";
import { Controller } from "react-hook-form";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Stack as Stack4,
  TextField
} from "@mui/material";
import { CurrencyIcon, CurrencyRealIcon } from "@clara/icons";
import { useLocaleContext as useLocaleContext2 } from "@clara/locale";
import { CurrencyField } from "@clara/ui";

// src/internal/components/help-center-panel/help-center-article/use-case-components/custom-dropzone.tsx
import { forwardRef, useMemo, useState as useState2 } from "react";
import { Box as Box2 } from "@mui/material";
import { Trans, useT as useT5 } from "@clara/locale";
import {
  LocaleProvider,
  Dropzone,
  useSnackbar as useSnackbar3,
  theme as theme3
} from "@clara/ui";
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var ID_DELETE_FILE = "delete-file-help-center";
var CustomDropzone = forwardRef(
  ({ ...props }, ref) => {
    const { t } = useT5(["common"]);
    const {
      attachFile: [{ loading }, onSubmit]
    } = useTicket();
    const snackbar = useSnackbar3();
    const [isDeletingFiles, setIsDeletingFiles] = useState2(false);
    const [files, setFiles] = useState2([]);
    const mimeType = useMemo(() => getMimeType(props.accept), [props.accept]);
    return /* @__PURE__ */ jsxs5(
      LocaleProvider,
      {
        locale: {
          dropzone: {
            subtitle: t("uploader.v3.subtitle"),
            button: t("uploader.v3.button"),
            caption: /* @__PURE__ */ jsx7(
              Trans,
              {
                t,
                i18nKey: "v3.uploader.captionAllowedFiles",
                components: {},
                values: { allowedFiles: props.accept }
              }
            ),
            deleteFile: t("uploader.v3.deleteFile"),
            loading: t("uploader.v3.loading"),
            viewFile: t("uploader.v3.viewFile"),
            downloadFile: t("uploader.v3.downloadFile")
          }
        },
        children: [
          /* @__PURE__ */ jsx7("input", { type: "hidden", ref }),
          /* @__PURE__ */ jsx7(
            Box2,
            {
              sx: {
                "p.MuiTypography-body2": {
                  wordBreak: "break-word",
                  maxHeight: theme3.typography.body2.lineHeight,
                  WebkitLineClamp: 1
                }
              },
              children: /* @__PURE__ */ jsx7(
                Dropzone,
                {
                  ...props,
                  accept: mimeType,
                  files,
                  isLoading: loading,
                  isDisabled: isDeletingFiles,
                  onDrop: (acceptedFiles) => {
                    Promise.all(
                      acceptedFiles.map(async (file) => {
                        const response = await onSubmit(file);
                        return response;
                      })
                    ).then(
                      (attachmentsToken) => Promise.all(
                        attachmentsToken.map(async (res) => {
                          const json = await (res == null ? void 0 : res.json());
                          return json;
                        })
                      )
                    ).then((attachments) => {
                      var _a;
                      const newTokens = attachments.map((attachment, index) => {
                        const token = attachment.upload.token;
                        acceptedFiles[index].token = token;
                        return token;
                      });
                      const oldTokens = files.map((file) => file.token);
                      setFiles([...files, ...acceptedFiles]);
                      (_a = props.onDrop) == null ? void 0 : _a.call(props, [...oldTokens, ...newTokens]);
                    });
                  },
                  onDelete: async (file) => {
                    var _a;
                    setIsDeletingFiles(true);
                    snackbar({
                      id: ID_DELETE_FILE,
                      message: t("uploader.deletingFile"),
                      status: "info",
                      position: "bottom-left"
                    });
                    const newFiles = files.filter((f) => f.name !== file.name);
                    (_a = props.onDelete) == null ? void 0 : _a.call(props, newFiles.map((f) => f.token));
                    setFiles(newFiles);
                    setIsDeletingFiles(false);
                    snackbar.close(ID_DELETE_FILE);
                  }
                }
              )
            }
          )
        ]
      }
    );
  }
);
CustomDropzone.displayName = "CustomDropzone";
var custom_dropzone_default = CustomDropzone;

// src/internal/components/help-center-panel/help-center-article/use-case-components/render-form.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var COMPANY_MANAGE_SUBSCRIPTION = "tickettype__company__manage_subscription";
var RenderForm = ({ formInputs, article }) => {
  const { setTicket } = useHelpCenterContext();
  const setSubject = (value) => {
    if (article.labels.includes(COMPANY_MANAGE_SUBSCRIPTION)) {
      setTicket({ subject: value });
    }
  };
  return /* @__PURE__ */ jsx8(Stack4, { spacing: 2, children: Array.from(formInputs).map((input, index) => {
    const inputType = input.getAttribute("data-type");
    if (inputType === "html" /* HTML */) {
      return /* @__PURE__ */ jsx8(render_html_default, { innerHTML: input.innerHTML }, index);
    }
    let defaultValue = input.getAttribute("data-field-value");
    if (!defaultValue && inputType === "checkbox" /* CHECKBOX */) {
      defaultValue = "false";
    }
    return /* @__PURE__ */ jsx8(
      Controller,
      {
        name: input.getAttribute("data-field-id"),
        defaultValue,
        render: ({ field, fieldState: error }) => /* @__PURE__ */ jsx8(
          RenderInput,
          {
            input,
            field,
            hasError: !!(error == null ? void 0 : error.error),
            setSubject
          }
        )
      },
      input.getAttribute("data-field-id")
    );
  }) });
};
var RenderInput = ({
  input,
  field,
  hasError,
  setSubject
}) => {
  const { locale } = useLocaleContext2();
  const inputType = input.getAttribute("data-type");
  const inputLabel = input.getAttribute("data-label");
  const isBrasilian = useMemo2(
    () => locale.preferences.id === "BR",
    [locale.preferences.id]
  );
  switch (inputType) {
    case "text" /* TEXT */:
      return /* @__PURE__ */ jsx8(TextField, { ...field, label: inputLabel, error: hasError, fullWidth: true });
    case "textarea" /* TEXTAREA */:
      return /* @__PURE__ */ jsx8(
        TextField,
        {
          ...field,
          label: inputLabel,
          error: hasError,
          rows: 4,
          value: field.value || "",
          fullWidth: true,
          multiline: true
        }
      );
    case "number" /* NUMBER */:
      return /* @__PURE__ */ jsx8(
        TextField,
        {
          ...field,
          type: "number",
          label: inputLabel,
          error: hasError,
          fullWidth: true
        }
      );
    case "currency" /* CURRENCY */:
      return /* @__PURE__ */ jsx8(
        CurrencyField,
        {
          ...field,
          InputProps: {
            startAdornment: /* @__PURE__ */ jsx8(InputAdornment, { position: "start", children: isBrasilian ? /* @__PURE__ */ jsx8(CurrencyRealIcon, {}) : /* @__PURE__ */ jsx8(CurrencyIcon, {}) })
          },
          label: inputLabel,
          error: hasError,
          inputProps: {
            thousandSeparator: ".",
            fixedDecimalScale: true,
            decimalScale: 2,
            decimalSeparator: ","
          },
          fullWidth: true
        }
      );
    case "attachment" /* ATTACHMENT */:
      return /* @__PURE__ */ jsx8(
        custom_dropzone_default,
        {
          ...field,
          onDelete: (tokens) => {
            field.onChange(tokens.length ? tokens : null);
          },
          onDrop: (tokens) => {
            field.onChange(tokens);
          },
          accept: input.getAttribute("data-allowedfiles") || void 0
        }
      );
    case "hidden" /* HIDDEN */:
      return /* @__PURE__ */ jsx8("input", { ...field, type: "hidden" });
    case "select" /* SELECT */:
      return /* @__PURE__ */ jsx8(
        custom_select_default,
        {
          ...field,
          element: input,
          label: inputLabel,
          setSubject,
          onChange: (value) => field.onChange(value)
        }
      );
    case "checkbox" /* CHECKBOX */:
      return /* @__PURE__ */ jsx8(FormGroup, { children: /* @__PURE__ */ jsx8(
        FormControlLabel,
        {
          ...field,
          control: /* @__PURE__ */ jsx8(Checkbox, { size: "small" }),
          label: inputLabel
        }
      ) });
    default:
      return null;
  }
};
var render_form_default = RenderForm;

// src/internal/components/help-center-panel/help-center-article/help-center-use-case.tsx
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["ATTACHMENT"] = "attachment";
  FieldType2["CHECKBOX"] = "checkbox";
  FieldType2["CURRENCY"] = "currency";
  FieldType2["HIDDEN"] = "hidden";
  FieldType2["HTML"] = "html";
  FieldType2["NUMBER"] = "number";
  FieldType2["SELECT"] = "select";
  FieldType2["TEXT"] = "text";
  FieldType2["TEXTAREA"] = "textarea";
  return FieldType2;
})(FieldType || {});
var UseCase = ({ article, adornments }) => {
  const container = document.createElement("div");
  container.innerHTML = article.body;
  const topDiv = container.querySelector("#top");
  const formInputs = container.querySelectorAll("#form .hidden");
  const bottomDiv = container.querySelector("#bottom");
  const formSchema = useMemo3(() => {
    var _a;
    if (!(article == null ? void 0 : article.body) || article.type !== "use_case" /* USE_CASE */ && article.type !== "init_flow" /* INIT_FLOW */) {
      return object().shape({});
    }
    const container2 = document.createElement("div");
    container2.innerHTML = (_a = article.body) != null ? _a : "";
    const formInputs2 = container2.querySelectorAll("#form .hidden");
    return object().shape(
      Array.from(formInputs2).reduce(
        (acc, curr) => {
          if (curr.hasAttribute("data-required")) {
            if (curr.getAttribute("data-type") === "attachment" /* ATTACHMENT */ || curr.getAttribute("data-multi") === "true") {
              acc[curr.getAttribute("data-field-id")] = mixed().required();
            } else if (curr.getAttribute("data-type") === "checkbox" /* CHECKBOX */) {
              acc[curr.getAttribute("data-field-id")] = bool().isTrue().required();
            } else {
              acc[curr.getAttribute("data-field-id")] = string().required();
            }
          }
          return acc;
        },
        {}
      )
    );
  }, [article.body, article.type]);
  const methods = useForm({
    resolver: yupResolver(formSchema),
    mode: "onChange"
  });
  return /* @__PURE__ */ jsxs6(FormProvider, { ...methods, children: [
    /* @__PURE__ */ jsxs6(Stack5, { gap: 2, pb: 12, children: [
      /* @__PURE__ */ jsx9("div", { className: "adornment", children: adornments == null ? void 0 : adornments.start }),
      !!topDiv && /* @__PURE__ */ jsx9(
        StyledContentWrapper,
        {
          dangerouslySetInnerHTML: { __html: topDiv.innerHTML }
        }
      ),
      !!formInputs.length && /* @__PURE__ */ jsx9(render_form_default, { formInputs, article }),
      !!bottomDiv && /* @__PURE__ */ jsx9(
        StyledContentWrapper,
        {
          dangerouslySetInnerHTML: { __html: bottomDiv.innerHTML }
        }
      ),
      /* @__PURE__ */ jsx9("div", { className: "adornment", children: adornments == null ? void 0 : adornments.end })
    ] }),
    /* @__PURE__ */ jsx9(UseCaseButton, { article })
  ] });
};
var help_center_use_case_default = withSanitize_default(UseCase);

// src/internal/components/help-center-panel/help-center-article/article.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var Article = ({
  resource,
  adornments
}) => {
  const article = resource.read();
  switch (article.type) {
    case "use_case" /* USE_CASE */:
      return /* @__PURE__ */ jsx10(help_center_use_case_default, { article, adornments });
    case "ticket" /* TICKET */:
    case "init_flow" /* INIT_FLOW */:
    case "informative" /* INFORMATIVE */:
    default:
      return /* @__PURE__ */ jsx10(help_center_common_article_default, { article });
  }
};

// src/internal/components/help-center-panel/help-center-article/help-center-article.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var HelpCenterArticle = ({
  id,
  adornments
}) => {
  const {
    article: [, onSubmit]
  } = useArticleRequest();
  const [resource, setResource] = useState3(null);
  const analytics = useAnalytics3();
  const { eventData } = useEvents();
  useEffect4(() => {
    if (!id)
      return;
    setResource(createResource(onSubmit(id)));
  }, [id, onSubmit]);
  useEffect4(() => {
    analytics.track(HelpCenterEvents.EXPERIENCE_HELPERSIDE_ARTICLE_OPEN, {
      ...eventData,
      action: "open_article",
      article: id
    });
  }, []);
  return /* @__PURE__ */ jsx11(
    help_center_error_boundary_default,
    {
      trackError: analytics.track,
      eventData: { ...eventData, action: "error" },
      children: /* @__PURE__ */ jsx11(Suspense2, { fallback: /* @__PURE__ */ jsx11(HelpCenterFallback, { showTitle: false }), children: resource && /* @__PURE__ */ jsx11(Article, { resource, adornments }) })
    }
  );
};

// src/internal/components/help-center-panel/hooks/useHelpCenter.tsx
import { useState as useState4 } from "react";
import { __DEV__ as __DEV__2 } from "@clara/utils";
var useHelpCenter = (zendeskHost) => {
  const [cachedArticles, setCachedArticles] = useState4(/* @__PURE__ */ new Map());
  const [articles, setArticles] = useState4(
    /* @__PURE__ */ new Map()
  );
  const [ticket, setTicket] = useState4({ subject: "" });
  const { sidePanel } = useLayoutContext();
  const updateCachedArticles = (key, articles2) => {
    setCachedArticles((prev) => new Map(prev.set(key, articles2)));
  };
  const setTicketInfo = (ticketInfo) => {
    setTicket({ ...ticket, ...ticketInfo });
  };
  const update = (article) => {
    setTicket({
      subject: article.title
    });
    setArticles((prev) => new Map(prev.set(article.id, article)));
  };
  const getArticle = (id) => {
    return articles.get(id);
  };
  const invokeArticle = (id, adornments) => {
    if (__DEV__2) {
      console.warn(
        "invokeArticle is deprecated and will be removed in a future release. Use `sidePanel.onOpen(createArticlePanelById(Number(id), adornments))` instead."
      );
    }
    if (isNaN(Number(id))) {
      if (__DEV__2)
        console.error("Invalid article id");
      return;
    }
    sidePanel.onOpen(createArticlePanelById(Number(id), adornments));
  };
  return {
    getArticle,
    update,
    invokeArticle,
    ticket,
    setTicket: setTicketInfo,
    zendeskHost,
    cachedArticles,
    updateCachedArticles
  };
};

// src/internal/components/help-center-panel/help-center-panel.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var [HelpCenterContextProvider, useHelpCenterContext] = createContext({
  name: "HelpCenterContextProvider",
  errorMessage: "useHelpCenterContext: `context` is undefined. Seems you forgot to wrap your component with `<HelpCenterContextProvider />`"
});
var HelpCenterProvider = ({
  zendeskHost,
  children: childrenProp
}) => {
  const ctx = useHelpCenter(zendeskHost);
  const context = useMemo4(() => ctx, [ctx]);
  const children = runIfFn(childrenProp, context);
  return /* @__PURE__ */ jsx12(HelpCenterContextProvider, { value: context, children });
};
var HelpCenterSidePanel = [
  {
    children: [
      {
        element: /* @__PURE__ */ jsx12(HelpCenterAssistant, {}),
        header: /* @__PURE__ */ jsx12(Translation, { ns: "common", children: (t) => /* @__PURE__ */ jsx12(
          SidePanelHeader,
          {
            variant: "alternate",
            headline: t("helpCenter.panel.headline"),
            tagline: t("helpCenter.panel.tagline")
          }
        ) }),
        footer: /* @__PURE__ */ jsx12(HelpCenterHandlerCloseEvent, { children: /* @__PURE__ */ jsx12(HelpCenterFooter, {}) })
      }
    ]
  }
];
var TicketCreatedPanel = [
  {
    children: [
      {
        element: /* @__PURE__ */ jsx12(HelpCenterTicketCreated, {}),
        footer: /* @__PURE__ */ jsx12(HelpCenterHandlerCloseEvent, { children: /* @__PURE__ */ jsx12(HelpCenterTicketCreatedFooter, {}) })
      }
    ]
  }
];
var createArticlePanelById = (id, adornments) => {
  return [
    {
      children: [
        {
          element: /* @__PURE__ */ jsx12(HelpCenterArticle, { id, adornments }),
          header: /* @__PURE__ */ jsx12(HelpCenterHandlerCloseEvent, { children: /* @__PURE__ */ jsx12(HelpCenterArticleTitle, { id }) })
        }
      ]
    }
  ];
};
var createArticlePanels = (currentPanelObjects, articleId, adornments) => [
  {
    children: [
      ...currentPanelObjects,
      getArticlePanelById(Number(articleId), adornments)
    ]
  }
];
var getArticlePanelById = (articleId, adornments) => {
  return {
    element: /* @__PURE__ */ jsx12(HelpCenterArticle, { id: articleId, adornments }),
    header: /* @__PURE__ */ jsx12(HelpCenterHandlerCloseEvent, { children: /* @__PURE__ */ jsx12(HelpCenterArticleTitle, { id: articleId }) })
  };
};

// src/internal/components/help-center-panel/hooks/useArticleRequest.tsx
var ArticleLabel = /* @__PURE__ */ ((ArticleLabel2) => {
  ArticleLabel2["INFORMATIVE"] = "informative";
  ArticleLabel2["TICKET"] = "ticket";
  ArticleLabel2["INIT_FLOW"] = "init_flow";
  ArticleLabel2["USE_CASE"] = "use_case";
  return ArticleLabel2;
})(ArticleLabel || {});
var useArticleRequest = () => {
  const request = useAuthFetch2();
  const { lang, locale } = useLocaleContext3();
  const { update, cachedArticles, updateCachedArticles, getArticle } = useHelpCenterContext();
  const auth = useAuthContext2();
  const API_URL = auth.config.url;
  const populateArticleType = (article2) => {
    let type = "informative" /* INFORMATIVE */;
    if (article2.labels.includes("informative"))
      type = "informative" /* INFORMATIVE */;
    else if (article2.labels.includes("init_flow"))
      type = "init_flow" /* INIT_FLOW */;
    else if (article2.labels.includes("ticket"))
      type = "ticket" /* TICKET */;
    else if (article2.labels.includes("use_case")) {
      type = "use_case" /* USE_CASE */;
    }
    return {
      ...article2,
      type
    };
  };
  const articleList = useAsyncFn2(
    async (search = "") => {
      const params = new URLSearchParams({
        country: locale.preferences.id,
        language: lang,
        path: window.location.pathname,
        query: search,
        page: "0",
        size: "5"
      }).toString();
      if (cachedArticles.has(params)) {
        return new Promise((resolve) => resolve(cachedArticles.get(params)));
      }
      const response = await request(
        `${API_URL}/help-center/articles/${!search ? "recommended" : "search"}?${params.toString()}`,
        {
          method: "GET"
        }
      );
      const articles = response.data.map(populateArticleType);
      updateCachedArticles(params, articles);
      return articles;
    },
    [request]
  );
  const article = useAsyncFn2(
    async (articleId) => {
      const params = new URLSearchParams({
        country: locale.preferences.id,
        language: lang
      });
      const cachedArticle = getArticle(articleId);
      if (cachedArticle && cachedArticle.body) {
        return new Promise((resolve) => resolve(cachedArticle));
      }
      const response = await request(
        `${API_URL}/help-center/articles/${articleId}?${params.toString()}`,
        {
          method: "GET"
        }
      );
      const article2 = populateArticleType(response);
      update(article2);
      return article2;
    },
    [request]
  );
  return { article, articleList };
};

export {
  ArticleLabel,
  useArticleRequest,
  HelpCenterArticleTitle,
  HelpCenterTicketCreated,
  render_html_default,
  HelpCenterAssistant,
  HelpCenterFallback,
  help_center_common_article_default,
  useTicket,
  UseCaseButton,
  custom_dropzone_default,
  render_form_default,
  FieldType,
  help_center_use_case_default,
  Article,
  HelpCenterArticle,
  useHelpCenter,
  useHelpCenterContext,
  HelpCenterProvider,
  HelpCenterSidePanel,
  TicketCreatedPanel,
  createArticlePanelById,
  createArticlePanels,
  getArticlePanelById
};
